import React, { useCallback, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import Box from 'transfix-ui/core/Box'
import AddStopModal from '../AddStopModal'

export const AddStopModalButton = () => {
  const [isOpen, setOpen] = useState<boolean>(false)

  const toggleModalHandler = useCallback((newVal?: boolean) => {
    setOpen(prev => {
      if (typeof newVal !== 'undefined') {
        return newVal
      }
      return !prev
    })
  }, [])

  const closeHandler = () => toggleModalHandler(false)

  return (
    <Box mr={1}>
      <AddStopModal open={isOpen} onClose={closeHandler} />
      <Button color='tertiary' onClick={toggleModalHandler}>
        Add Stop
      </Button>
    </Box>
  )
}
